import React, { useMemo } from 'react';

type PlanProgressProps = {
	completed?: number;
	total?: number;
	label?: string;
};

const PLAN_MIN_COMPLETED = 0.7;

const PlanProgress: React.FC<PlanProgressProps> = ({ completed = 0, total = 0, label = 'Plan progress' }) => {
	const progress = useMemo(() => {
		if (!total) return 0;
		return Math.min(completed / total, 1);
	}, [completed, total]);

	const percent = Math.round(progress * 100);
	const isComplete = progress >= PLAN_MIN_COMPLETED;

	return (
		<div className='flex flex-col gap-3 rounded-2xl bg-white p-4'>
			<div className='flex items-center justify-between'>
				<span className='text-base font-semibold text-[#02393E]'>{label}</span>
				<span className='text-xs text-[#9392AD]'>
					{completed}/{total} activities completed
				</span>
			</div>

			<div className='flex items-center gap-2 rounded-full bg-[#ECEDF5] px-2.5 py-1.5'>
				<span className='min-w-[40px] text-right text-sm font-semibold text-[#5E639B]'>{percent}%</span>

				<div className='relative h-2 flex-1'>
					<div className='h-2 w-full overflow-hidden rounded-full bg-white'>
						<div
							className='h-full rounded-full transition-all duration-300 ease-in-out'
							style={{
								width: `${percent}%`,
								background: 'linear-gradient(90deg, #7672B8, #9FD5A9, #C8F9CD)',
							}}
						/>
					</div>

					<div
						className={`absolute -top-[4px] flex h-4 w-4 -translate-x-1/2 items-center justify-center rounded-full border bg-white ${isComplete ? 'border-[#C3F0CC]' : 'border-[#ECEBF8]'}`}
						style={{ left: `${PLAN_MIN_COMPLETED * 100}%` }}
					>
						<div className={`h-2 w-2 rounded-full ${isComplete ? 'bg-[#C3F0CC]' : 'bg-[#ECEBF8]'}`} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PlanProgress;
